import React, { useState } from "react";
import Image from "next/image";
import User from "./User";
import CartNav from "./Cart";
import { useMutation, useQuery } from "@apollo/client";
import { RESEND_EMAIL_VERIFICATION, USER_INFO } from "../../../gql/user";
import { useCookies } from "react-cookie";
import {
  Navbar,
  Nav,
  Container,
  NavDropdown,
  Alert,
  Offcanvas,
  OffcanvasTitle,
  OffcanvasHeader,
  OffcanvasBody,
} from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import Link from "next/link";
import { Button, Grid } from "@pmberjaya/cloudbank-ui";
import { useRouter } from "next/dist/client/router";
import { toast } from "react-toastify";

const headerLink = [
  {
    name: "Domain",
    link: `${process.env.REACT_APP_DOMAIN}domain-murah`,
    desc: "Domain murah dan terpercaya",
    logo: <i className="bi bi-globe fs-2 text-primary"></i>,
  },
  {
    name: "Cloud Hosting",
    link: `${process.env.REACT_APP_DOMAIN}hosting-murah`,
    desc: "Cloud Hosting dengan storage SSD super cepat",
    logo: <i className="bi bi-hdd fs-2 text-primary"></i>,
  },
  {
    name: "Cloud Vps",
    link: `${process.env.REACT_APP_DOMAIN}vps-murah`,
    desc: "Cloud VPS dengan performa super cepat",
    logo: <i className="bi bi-cloud fs-2 text-primary"></i>,
  },
  {
    name: "colocation",
    link: `${process.env.REACT_APP_DOMAIN}colocation-server`,
    desc: "Colocation Server murah dan super cepat",
    logo: <i className="bi bi-server fs-2 text-primary"></i>,
  },
  {
    name: "rack solution",
    link: `${process.env.REACT_APP_DOMAIN}rack-solution`,
    desc: "Rack Solution Server performa super cepat",
    logo: <i className="bi bi-hdd-rack fs-2 text-primary"></i>,
  },
  {
    name: "promo",
    link: `${process.env.REACT_APP_DOMAIN}promo`,
    desc: "Beli produk apapun lebih murah!",
    logo: <i className="bi bi-percent fs-2 text-primary"></i>,
  },
  // {
  //   name: "kemitraan",
  //   link: "https://cloudbank.id/afiliasi",
  // },
  //   {
  //     name: "masuk",
  //     link: "",
  //   },
  //   {
  //     name: "daftar",
  //     link: "",
  //   },
];

const partnerLink = [
  {
    name: "afiliasi",
    link: `${process.env.REACT_APP_DOMAIN}afiliasi`,
    desc: "Dapatkan penghasilan pasif dengan komisi 75%",
    logo: <i className="bi bi-people fs-2 text-primary"></i>,
  },
  {
    name: "reseller",
    link: `${process.env.REACT_APP_DOMAIN}reseller`,
    desc: "Bergabunglah dan bangun bisnis baru Anda",
    logo: <i className="bi bi-diagram-3 fs-2 text-primary"></i>,
  },
];

const solutionLink = [
  {
    name: "e-commerce",
    link: `${process.env.REACT_APP_NEW_DOMAIN}e-commerce`,
  },
  {
    name: "instansi pendidikan",
    link: `${process.env.REACT_APP_NEW_DOMAIN}instansi-pendidikan`,
  },
  {
    name: "organisasi non profit",
    link: `${process.env.REACT_APP_NEW_DOMAIN}organisasi-non-profit`,
  },
  {
    name: "blog pribadi",
    link: `${process.env.REACT_APP_NEW_DOMAIN}blog-pribadi`,
  },
  {
    name: "start up",
    link: `${process.env.REACT_APP_NEW_DOMAIN}start-up`,
  },
  {
    name: "umkm",
    link: `${process.env.REACT_APP_NEW_DOMAIN}umkm`,
  },
  {
    name: "sofware company",
    link: `${process.env.REACT_APP_NEW_DOMAIN}software-company`,
  },
];
const NavBar = () => {
  const { loading, error, data } = useQuery(USER_INFO);
  const [cookie] = useCookies();
  const [show, setShow] = useState(false);
  const [showProduk, setShowProduk] = useState(false);
  const [showPartner, setShowPartner] = useState(false);
  const [showSolution, setShowSolution] = useState(false);

  const isMobile = useMediaQuery({ maxWidth: 350 });
  const isDesktop = useMediaQuery({ maxWidth: 1200 });
  const buttonMobile = useMediaQuery({ maxWidth: 767 });
  const router = useRouter();
  const [resentVerification] = useMutation(RESEND_EMAIL_VERIFICATION, {
    onCompleted: (resp) => {
      alert(`${resp.user.user.resend_verification} resend to your email!`);
    },
    onError: (resp) => {
      toast(resp.message, {
        type: toast.TYPE.ERROR,
        position: toast.POSITION.BOTTOM_LEFT,
      });
    },
  });
  const handleVerif = () => {
    resentVerification();
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const showDropdownProduk = (e) => {
    setShowProduk(!show);
  };
  const hideDropdownProduk = (e) => {
    setShowProduk(false);
  };
  const showDropdownPartner = (e) => {
    setShowPartner(!show);
  };
  const hideDropdownPartner = (e) => {
    setShowPartner(false);
  };
  const showDropdownSolution = (e) => {
    setShowSolution(!show);
  };
  const hideDropdownSolution = (e) => {
    setShowSolution(false);
  };
  return (
    <div className="navbar-cloudbank">
      {loading
        ? ""
        : error
        ? ""
        : data.me.is_verified === 0 &&
          router.pathname !== "/myprofile/user-verification" && (
            <Alert variant="warning" className="alert-verif mb-0">
              <div className="d-flex justify-content-between align-items-center ">
                <div>
                  Kami telah mengirimkan email verifikasi ke alamat email Anda,
                  mohon untuk memeriksa kotak masuk Anda. Tidak menerima
                  verifikasi email?
                </div>
                <div>
                  <Button
                    onClick={handleVerif}
                    color="warning"
                    variant="contained"
                    size="large"
                  >
                    {" "}
                    Kirim Ulang Verifikasi
                  </Button>
                </div>
              </div>
            </Alert>
            //  null
          )}
      <Navbar
        variant="dark"
        // fixed="top"
        expand="xl"
        className={`bg-primary  px-4 text-center align-items-center justify-content-center text-light `}
      >
        <Container fluid className="ps-1 pe-1">
          <Navbar.Brand
            href={`${process.env.REACT_APP_NEW_DOMAIN}`}
            className="me-0"
          >
            {/* <img src="/image/cloudbank.png" className={`${buttonMobile?"navLogoMobile":"navLogoDesktop"}`} alt="logo"/> */}
            {/* <Image
                src="/image/cloudbank.png"
                width={160}
                height={71.42}
                alt="cloudbank"
              /> */}
            <Image
              src="/image/cloudbankWhite.png"
              width={160}
              height={71.42}
              alt="cloudbank"
            />
          </Navbar.Brand>

          {/* {isDesktop ? (
            <>
              {cookie?.access_token === undefined ? (
                <>
                  <div
                    onClick={() => window.open("https://cloudbank.id/login")}
                    className={`btn btn-blue  m-2 text-uppercase  fs-4 border-2 border-secondary text-secondary ${
                      buttonMobile ? "d-none" : null
                    }`}
                  >
                    masuk
                  </div>
                  <div
                    onClick={() => window.open("https://cloudbank.id/register")}
                    className={`btn btn-secondary  text-uppercase  fs-4 text-primary m-2 ${
                      buttonMobile ? "d-none" : null
                    }`}
                  >
                    daftar
                  </div>
                </>
              ) : (
                <>
                  <CartNav />
                  <User loading={loading} error={error} data={data} />
                </>
              )}
            </>
          ) : null} */}

          <div
            className={`d-xl-none d-xxl-none ${
              isMobile && `nav-header-img ms-3`
            } ms-auto d-flex me-2`}
          >
            {cookie?.access_token === undefined ? (
              <div className="	d-none d-md-flex">
                <Button
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_NEW_DOMAIN}login`,
                      "_self"
                    )
                  }
                  className={`border-radius-10 text-uppercase px-4 fs-4 text-light m-2 border-light 	 `}
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  masuk
                </Button>
                {/* <Button variant="contained" color="primary">
                  masuk
                </Button> */}
                <Button
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_DOMAIN}register`,
                      "_self"
                    )
                  }
                  className={`border-radius-10 text-uppercase px-4 fs-4 text-primary m-2 border-primary 	 `}
                  variant="contained"
                  color="light"
                >
                  daftar
                </Button>
              </div>
            ) : (
              <>
                <CartNav />
                <User loading={loading} error={error} data={data} />
              </>
            )}
          </div>
          <Navbar.Toggle className="ms-2 p-0 " onClick={handleShow} />
          <Offcanvas
            // className={`${buttonMobile ? "h-100" : "h-75"}`}
            className="h-auto"
            show={show}
            onHide={handleClose}
            placement="top"
            scroll
          >
            <OffcanvasHeader className="bg-primary" closeButton>
              <OffcanvasTitle>
                <Image
                  src="/image/cloudbankWhite.png"
                  width={160}
                  height={71.42}
                  alt="cloudbank"
                />
              </OffcanvasTitle>
            </OffcanvasHeader>
            <OffcanvasBody>
              <div className="p-2">
                <Grid row className="my-2">
                  <h6 className="text-secondary text-uppercase fw-bold pb-2">
                    Produk
                  </h6>
                  {headerLink.map((row) => (
                    <Grid col xs={6} sm={6} md={4}>
                      <div
                        className="d-flex mx-2 pointer "
                        onClick={() => window.open(`${row.link}`, "_self")}
                      >
                        {row.logo}
                        <div className="ms-3">
                          <h5 className="mb-1 text-primary text-uppercase text-bold">
                            {row.name}
                          </h5>
                          <p className="text-secondary lh-1 fw-light">
                            {row.desc}
                          </p>
                        </div>
                      </div>
                    </Grid>
                  ))}
                  <h6 className="text-secondary text-uppercase fw-bold mt-3 pb-2">
                    KEMITRAAN
                  </h6>
                  {partnerLink.map((row) => (
                    <Grid col xs={6} sm={6} md={4}>
                      <div
                        className="d-flex mx-2 pointer "
                        onClick={() => window.open(`${row.link}`, "_self")}
                      >
                        {row.logo}
                        <div className="ms-3">
                          <h5 className="mb-1 text-primary text-uppercase text-bold">
                            {row.name}
                          </h5>
                          <p className="text-secondary lh-1 fw-light">
                            {row.desc}
                          </p>
                        </div>
                      </div>
                    </Grid>
                  ))}

                  <h6 className="text-secondary text-uppercase fw-bold mt-3 pb-2">
                    SOLUSI BISNIS
                  </h6>
                  {solutionLink.map((row) => (
                    <Grid col xs={6} sm={6} md={4}>
                      <div
                        className="d-flex mx-2 pointer "
                        onClick={() => window.open(`${row.link}`, "_self")}
                      >
                        {row.logo}
                        <div className="ms-3">
                          <h5 className="mb-1 text-primary text-uppercase text-bold">
                            {row.name}
                          </h5>
                          <p className="text-secondary lh-1 fw-light">
                            {row.desc}
                          </p>
                        </div>
                      </div>
                    </Grid>
                  ))}
                </Grid>
                {cookie?.access_token === undefined ? (
                  <div className={` d-flex justify-content-around`}>
                    <Button
                      variant="outlined"
                      size="large"
                      fullWidth
                      className="mx-2"
                      onClick={() =>
                        window.open(
                          `${process.env.REACT_APP_NEW_DOMAIN}login`,
                          "_self"
                        )
                      }
                    >
                      Masuk
                    </Button>
                    <Button
                      variant="contained"
                      className="mx-2"
                      size="large"
                      fullWidth
                      onClick={() =>
                        window.open(
                          `${process.env.REACT_APP_DOMAIN}register`,
                          "_self"
                        )
                      }
                    >
                      Daftar
                    </Button>
                  </div>
                ) : null}
              </div>
            </OffcanvasBody>
          </Offcanvas>

          {/* <Navbar.Collapse id="basic-navbar-nav"> */}
          {!isDesktop && (
            <Nav className={`align-middle ms-auto`}>
              {/* {headerLink.map((row) => (
                <Nav.Link
                  key={row.id}
                  href={row.link}
                  className={` text-uppercase fw-bold px-3 fs-5 text-light bg-primary`}
                >
                  {row.name}
                </Nav.Link>
              ))} */}
              {/* <NavDropdown
                className={`fw-bold px-2 fs-5 text-light bg-primary`}
                title="PRODUK"
                align="end"
                id="basic-nav-dropdown"
                show={showProduk}
                onMouseEnter={showDropdownProduk}
                onMouseLeave={hideDropdownProduk}
              >
                <div className="text-start custom-width-400">
                  <div className="px-3">
                    {headerLink
                      .filter((item) => item.name !== "promo")
                      .map((row) => (
                        <div
                          className="d-flex align-items-center my-3 pointer "
                          onClick={() => window.open(`${row.link}`, "_self")}
                        >
                          {row.logo}
                          <div className="ms-3">
                            <h5 className="mb-0 text-primary text-uppercase text-bold">
                              {row.name}
                            </h5>
                            <p className="text-secondary mb-0 fw-light">
                              {row.desc}
                            </p>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </NavDropdown> */}
              {/* <Nav.Link
                href={`${process.env.REACT_APP_DOMAIN}promo`}
                className={` text-uppercase fw-bold px-3 fs-5 text-light bg-primary`}
              >
                PROMO
              </Nav.Link> */}
              {/* <NavDropdown
                className={`fw-bold px-2 fs-5 text-light bg-primary`}
                title="KEMITRAAN"
                align="end"
                id="basic-nav-dropdown"
                show={showPartner}
                onMouseEnter={showDropdownPartner}
                onMouseLeave={hideDropdownPartner}
              >
                <div className="text-start custom-width-400">
                  <div className="px-3">
                    {partnerLink
                      .filter((item) => item.name !== "promo")
                      .map((row) => (
                        <div
                          className="d-flex align-items-center my-3 pointer "
                          onClick={() => window.open(`${row.link}`, "_self")}
                        >
                          {row.logo}
                          <div className="ms-3">
                            <h5 className="mb-0 text-primary text-uppercase text-bold">
                              {row.name}
                            </h5>
                            <p className="text-secondary mb-0 fw-light">
                              {row.desc}
                            </p>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </NavDropdown> */}

              {/* <NavDropdown
                className={`fw-bold px-2 fs-5 text-light bg-primary`}
                title="SOLUSI BISNIS"
                align="end"
                id="basic-nav-dropdown"
                show={showSolution}
                onMouseEnter={showDropdownSolution}
                onMouseLeave={hideDropdownSolution}
              >
                <div className="text-start custom-width-400">
                  <div className="px-3">
                    {solutionLink.map((row) => (
                      <div
                        className="d-flex align-items-center my-3 pointer "
                        onClick={() => window.open(`${row.link}`, "_self")}
                      >
                        {row.logo}
                        <div className="ms-3">
                          <h5 className="mb-0 text-primary text-uppercase text-bold">
                            {row.name}
                          </h5>
                          <p className="text-secondary mb-0 fw-light">
                            {row.desc}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </NavDropdown> */}

              {cookie?.access_token === undefined ? (
                <div className={`${buttonMobile ? "" : "d-none"}`}>
                  <Nav.Link href={`${process.env.REACT_APP_NEW_DOMAIN}login`}>
                    <div className="cs-full-width">
                      <Button
                        color="light"
                        variant="contained"
                        className={`border-radius-10 text-uppercase p-2 text-primary ${
                          buttonMobile ? "" : "d-none"
                        }`}
                        fullWidth
                      >
                        Masuk
                      </Button>
                    </div>
                  </Nav.Link>
                  <Nav.Link href={`${process.env.REACT_APP_DOMAIN}register`}>
                    <div className="cs-full-width">
                      <Button
                        color="light"
                        variant="contained"
                        className={`border-radius-10 text-uppercase p-2 text-primary${
                          buttonMobile ? "" : "d-none"
                        }`}
                        fullWidth
                      >
                        Daftar
                      </Button>
                    </div>
                  </Nav.Link>
                </div>
              ) : null}
            </Nav>
          )}

          {/* </Navbar.Collapse> */}
          {/* {isMobile ? (
            <div></div>
          ) : (
            <>
              {cookie?.access_token === undefined ? (
                <div>
                  <button
                    onClick={() => window.open("https://cloudbank.id/login")}
                    className={`btn btn-blue  me-1 text-uppercase  fs-4 border-2 border-secondary text-secondary ${
                      isDesktop ? "d-none" : null
                    }`}
                  >
                    masuk
                  </button>
                  <div
                    onClick={() => window.open("https://cloudbank.id/register")}
                    className={`btn btn-secondary  text-uppercase  fs-4 text-primary m-2 ${
                      isDesktop ? "d-none" : null
                    }`}
                  >
                    daftar
                  </div>
                </div>
              ) : (
                <div className={`${isDesktop && "d-none"}`}>
                  <CartNav />
                  <User loading={loading} error={error} data={data} />
                </div>
              )}
            </>
          )} */}
          <div className="d-none d-xl-flex">
            {cookie?.access_token === undefined ? (
              <>
                <Button
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_NEW_DOMAIN}login`,
                      "_self"
                    )
                  }
                  className={`border-radius-10 text-uppercase px-4 fs-4 text-light m-2 border-light	 `}
                  variant="contained"
                  color="primary"
                >
                  masuk
                </Button>
                {/* <Button variant="outlined" color="primary">
                    Masuk
                </Button> */}
                <Button
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_DOMAIN}register`,
                      "_self"
                    )
                  }
                  className={`border-radius-10 text-uppercase px-4 fs-4 text-primary m-2 border-light 	 `}
                  variant="contained"
                  color="light"
                >
                  daftar
                </Button>
              </>
            ) : (
              <>
                <CartNav />
                <User loading={loading} error={error} data={data} />
              </>
            )}
          </div>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavBar;
